<template>
  <div class="case-creation__step case-creation__Case-information">
    <div class="case-creation__card">
      <div class="case-creation__heading edit-view">
        <div class="title-with-icon">
          <span class="icon">
            <img
              src="@/assets/images/icons/icon-case-info.svg"
              alt="icon"
              class="img-fluid"
            />
          </span>
          <h3 class="title">Case Information</h3>
        </div>
      </div>
      <div class="case-creation__body pb-0" v-loading="loading">
        <el-row :gutter="15">
          <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
            <div
              class="input-value view-cases"
              v-if="getCaseInformation && getCaseInformation.case_types"
            >
              <h4 class="name">Case Type</h4>
              <ul>
                <li
                  v-for="(caseType, index) of getCaseInformation.case_types"
                  :key="index"
                >
                  {{ getCaseInformation && getCaseInformation.is_mileage_case && ($route.name == 'MilageCaseView' || $route.name == 'Mileage-Case-Information-Update') ? "Mileage" : caseTypeMap[caseType] }}
                </li>
              </ul>
            </div>
          </el-col>
          <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12"  v-if="getCaseInformation?.is_stat &&  !showStatCase()">
            <div class="input-value view-cases">
              <h4 class="name">STAT Case</h4>
              <p
                class="value"
                style="background: #BF1B39; width: 42px ; height: 18px; border-radius: 10px; padding-left: 14px;  color: white;"
                v-if="getCaseInformation && getCaseInformation?.is_stat"
              >
                Yes
              </p>
              <p class="value" v-else>--</p>
            </div>
          </el-col>
          <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
            <div class="input-value view-cases">
              <h4 class="name">Laboratory</h4>
              <p
                class="value"
                v-if="getCaseInformation && getCaseInformation.lab"
              >
                {{ getCaseInformation.lab.name }}
              </p>
              <p class="value" v-else>--</p>
            </div>
          </el-col>
          <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
            <div
              class="input-value view-cases"
              v-if="getCaseInformation && getCaseInformation.collection_date"
            >
              <h4 class="name">Collection Date</h4>
              <p class="value">
                {{
                  momentWithTimezoneTime(
                    getCaseInformation.collection_date,
                    "MM-DD-yyyy hh:mm A"
                  )
                }}
              </p>
            </div>
          </el-col>
          <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
            <div
              class="input-value view-cases"
              v-if="getCaseInformation && getCaseInformation.received_date"
            >
              <h4 class="name">Received Date</h4>
              <p class="value">
                {{
                  momentWithTimezoneTime(
                    getCaseInformation.received_date,
                    "MM-DD-yyyy hh:mm A"
                  )
                }}
              </p>
            </div>
          </el-col>
          <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
            <div class="input-value view-cases">
              <h4 class="name">Ordering Facility</h4>
              <p
                class="value"
                v-if="getCaseInformation && getCaseInformation.hospital"
              >
                {{ getCaseInformation.hospital.name }}
              </p>
              <p class="value" v-else>--</p>
            </div>
          </el-col>

          <el-col
            :xl="3"
            :lg="4"
            :md="8"
            :sm="12"
            :xs="12"
            v-if="!isBillingUser"
          >
            <div class="input-value view-cases">
              <h4 class="name">Ordering Facility State</h4>
              <p
                class="value"
                v-if="getCaseInformation && getCaseInformation.hospital"
              >
                {{ getCaseInformation.hospital.state }}
              </p>
              <p class="value" v-else>--</p>
            </div>
          </el-col>
          <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
            <div class="input-value view-cases">
              <h4 class="name">Ordering Facility Branch</h4>
              <p
                class="value"
                v-if="getCaseInformation && getCaseInformation.hospital_branch"
              >
                {{ getCaseInformation.hospital_branch.display_name }}
              </p>
              <p class="value" v-else>--</p>
            </div>
          </el-col>
          <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
            <div class="input-value view-cases">
              <h4 class="name">Ordering Physician</h4>
              <p
                class="value"
                v-if="
                  getCaseInformation && getCaseInformation.ordering_physician
                "
              >
                {{ getCaseInformation.ordering_physician.name }}
              </p>
              <p class="value" v-else>--</p>
            </div>
          </el-col>
          <el-col
            :xl="3"
            :lg="4"
            :md="8"
            :sm="12"
            :xs="12"
            v-if="!isBillingUser"
          >
            <div class="input-value view-cases">
              <h4 class="name">Ordering Physician NPI</h4>
              <p
                class="value"
                v-if="
                  getCaseInformation && getCaseInformation.ordering_physician
                "
              >
                {{ getCaseInformation.ordering_physician.npi_code }}
              </p>
              <p class="value" v-else>--</p>
            </div>
          </el-col>
          <el-col
            :xl="2"
            :lg="6"
            :md="6"
            :sm="8"
            :xs="8"
            v-if="!isBillingUser"
          >
            <div class="input-value view-cases">
              <h4 class="name">Pecos Status</h4>

              <div class="recheckBtn">
                <el-tag
                  type="success"
                  size="large"
                  round
                  v-if="physicianInfo && physicianInfo.pecos_status"
                  class="mb-10"
                  style="cursor: pointer"
                  @click="openPhysicianDetails"
                >
                  PECOS Verified
                  <el-icon>
                    <Finished />
                  </el-icon>
                </el-tag>
                <el-tag
                  type="danger"
                  size="large"
                  round
                  v-else
                  class="mb-10 mr-10"
                >
                  PECOS Not Verified
                  <el-icon>
                    <Finished />
                  </el-icon>
                </el-tag>
                <el-button
                  class="btn radius-button mb-10"
                  v-if="
                    physicianInfo &&
                    (physicianInfo.pecos_status == false ||
                      !physicianInfo.pecos_status)
                  "
                  @click="reCheckPecosStatus"
                >
                  Recheck For PECOS
                </el-button>
              </div>
            </div>
          </el-col>
          <el-col
            :xl="2"
            :lg="6"
            :md="6"
            :sm="8"
            :xs="8"
            v-if="!isBillingUser"
          >
            <div class="input-value view-cases">
              <h4 class="name">Enrolled Status</h4>

              <div class="recheckBtn">
                <el-tag
                  type="success"
                  size="large"
                  round
                  v-if="physicianInfo && physicianInfo.is_enrolled"
                  class="mb-10"
                  style="cursor: pointer"
                >
                  Enrolled
                  <el-icon>
                    <Finished />
                  </el-icon>
                </el-tag>
                <el-tag
                  type="danger"
                  size="large"
                  round
                  v-else
                  class="mb-10 mr-10"
                >
                  Not Enrolled
                  <el-icon>
                    <Finished />
                  </el-icon>
                </el-tag>
                <el-button
                  class="btn radius-button mb-10"
                  v-if="
                    physicianInfo &&
                    !physicianInfo.is_enrolled
                  "
                  @click="checkPhysicianEnroll()"
                >
                  Check Enrolled
                </el-button>
              </div>
            </div>
          </el-col>
          <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
            <div class="input-value view-cases">
              <h4 class="name">Referring Physician</h4>
              <p
                class="value"
                v-if="
                  getCaseInformation && getCaseInformation.referring_physician
                "
              >
                {{ getCaseInformation.referring_physician.name }}
              </p>
              <p class="value" v-else>--</p>
            </div>
          </el-col>
          <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
            <div class="input-value view-cases">
              <h4 class="name">Bill To</h4>
              <p
                class="value"
                v-if="getCaseInformation && getCaseInformation.billing_type"
              >
                {{ getCaseInformation.billing_type }}
              </p>
              <p class="value" v-else>--</p>
            </div>
          </el-col>
          <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
            <div class="input-value view-cases">
              <h4 class="name">Order ID</h4>
              <p
                class="value"
                v-if="getCaseInformation && getCaseInformation.order_id"
              >
                {{ getCaseInformation.order_id }}
              </p>
              <p class="value" v-else>--</p>
            </div>
          </el-col>

          <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
            <div class="input-value view-cases">
              <h4 class="name">Specimen Collector</h4>
              <p
                class="value"
                v-if="
                  getCaseInformation && getCaseInformation.specimen_collector
                "
              >
                {{ getCaseInformation.specimen_collector }}
              </p>
              <p class="value" v-else>--</p>
            </div>
          </el-col>
          <el-col :xl="12" :lg="12" :md="8" :sm="12" :xs="12">
            <div class="input-value view-cases icd-codes">
              <div class="indicatives">
                <h4 class="name">ICD-10 (Indicative)</h4>
                <ul
                  v-if="getCaseInformation && getCaseInformation.icd_10_codes"
                >
                  <li
                    class="value"
                    v-for="(
                      icd_10_code, index
                    ) in getCaseInformation.icd_10_codes"
                    :key="index"
                  >
                    {{ icd_10_code }}
                  </li>
                </ul>
              </div>
            </div>
          </el-col>
          <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
            <div class="input-value view-cases">
              <h4 class="name">Additional Fax Receiver Name</h4>
              <p
                class="value"
                v-if="
                  getCaseInformation &&
                  getCaseInformation.additional_fax_requisite
                "
              >
                {{ getCaseInformation.additional_fax_requisite }}
              </p>
              <p class="value" v-else>--</p>
            </div>
          </el-col>
          <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
            <div class="input-value view-cases">
              <h4 class="name">Additional Fax Number</h4>
              <ul
                class="value"
                v-if="
                  getCaseInformation &&
                  getCaseInformation.additional_fax &&
                  getCaseInformation.additional_fax.length
                "
              >
                <li
                  v-for="(fax, index) in getCaseInformation.additional_fax"
                  :key="index"
                >
                  <span>
                    {{ fax }}
                  </span>
                </li>
              </ul>

              <p class="value" v-else>--</p>
            </div>
          </el-col>
          <el-col :xl="6" :lg="12" :md="12">
            <div class="input-value view-cases">
              <div
                class="speciment-type-view"
                v-if="getCaseInformation && getCaseInformation.sample_types"
              >
                <div>
                  <h4 class="name">Specimen Types</h4>
                  <ul
                    class="case_type"
                    v-if="
                      getCaseInformation.sample_types &&
                      getCaseInformation.sample_types.length
                    "
                  >
                    <li
                      class="value"
                      v-for="(
                        sampleType, index
                      ) in getCaseInformation.sample_types"
                      :key="index"
                    >
                      {{ caseTypeMap[sampleType.case_type] }}
                    </li>
                  </ul>
                  <ul v-else>
                    --
                  </ul>
                </div>
                <div>
                  <h4 class="name">&nbsp;</h4>

                  <ul
                    class="speciment_type"
                    v-if="
                      getCaseInformation.sample_types &&
                      getCaseInformation.sample_types.length
                    "
                  >
                    <li
                      v-for="(
                        sampleType, index
                      ) in getCaseInformation.sample_types"
                      :key="index"
                    >
                      <span
                        v-if="
                          sampleType.sample_types &&
                          sampleType.sample_types.length
                        "
                      >
                        <span
                          v-for="(sample, index) in sampleType.sample_types"
                          :key="index"
                        >
                          {{ sample }}
                          <span
                            v-if="index + 1 < sampleType.sample_types.length"
                            >,</span
                          >
                        </span>
                      </span>
                      <span v-else> -- </span>
                    </li>
                  </ul>
                  <ul v-else>
                    --
                  </ul>
                </div>
              </div>
            </div>
          </el-col>
          <el-col :xl="6" :lg="8" :md="8" :sm="8" :xs="8" v-if="!isBillingUser">
            <div class="input-value view-cases cpt-codes">
              <div class="indicatives">
                <h4 class="name">CPT Codes</h4>
                <ul
                  v-if="
                    getCaseInformation &&
                    getCaseInformation.cpt_codes &&
                    getCaseInformation.cpt_codes.length
                  "
                >
                  <li
                    v-for="(cpt_code, index) in getCaseInformation.cpt_codes"
                    :key="index"
                  >
                    {{ cpt_code }}
                  </li>
                </ul>
                <ul v-else>
                  --
                </ul>
              </div>
            </div>
          </el-col>
          <el-col
            :xl="3"
            :lg="3"
            :md="3"
            :sm="3"
            :xs="3"
            v-if="
              hadClinicalChemistry &&
              (getCaseInformation.is_fasting == false ||
                getCaseInformation.is_fasting == true) &&
              getCaseInformation.order_id
            "
          >
            <div class="input-value view-cases">
              <h4 class="name">Fasting</h4>
              <p class="value">
                {{ getCaseInformation.is_fasting ? "Yes" : "No" }}
              </p>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
  <div class="default-modal" v-if="physicianDetailsPopUp">
    <el-dialog
      width="70%"
      v-model="physicianDetailsPopUp"
      title="Physician Details"
    >
      <div class="dialog-header">
        <span class="header-part"> Physician Details </span>
        <el-button @click="physicianDetailsPopUp = false">
          <img src="@/assets/images/icons/cases/close-btn.svg" alt="icon"
        /></el-button>
      </div>
      <div>
        <div class="case-creation__body pb-0">
          <div class="vue-form">
            <el-row :gutter="20">
              <el-col :xl="4" :lg="4" :md="8" :sm="12" :xs="12">
                <div class="input-value">
                  <h4 class="name">Full Name</h4>

                  <p class="value">{{ this.physicianInfo.name }}</p>
                </div>
              </el-col>
              <el-col :xl="4" :lg="4" :md="8" :sm="12" :xs="12">
                <div class="input-value">
                  <h4 class="name">First Name</h4>

                  <p class="value">
                    {{
                      this.physicianInfo.first_name
                        ? this.physicianInfo.first_name
                        : "--"
                    }}
                  </p>
                </div>
              </el-col>
              <el-col :xl="4" :lg="4" :md="8" :sm="12" :xs="12">
                <div class="input-value">
                  <h4 class="name">Middle Name</h4>

                  <p class="value">
                    {{
                      this.physicianInfo.middle_name
                        ? this.physicianInfo.middle_name
                        : "--"
                    }}
                  </p>
                </div>
              </el-col>
              <el-col :xl="4" :lg="4" :md="8" :sm="12" :xs="12">
                <div class="input-value">
                  <h4 class="name">Last Name</h4>

                  <p class="value">
                    {{
                      this.physicianInfo.last_name
                        ? this.physicianInfo.last_name
                        : "--"
                    }}
                  </p>
                </div>
              </el-col>
              <el-col :xl="4" :lg="4" :md="8" :sm="12" :xs="12">
                <div class="input-value">
                  <h4 class="name">UPIN/NPI</h4>
                  <p class="value" v-if="this.physicianInfo.npi_code">
                    {{ this.physicianInfo.npi_code }}
                  </p>
                </div>
              </el-col>
              <el-col :xl="4" :lg="4" :md="8" :sm="12" :xs="12">
                <div class="input-value">
                  <h4 class="name">Phone Number</h4>
                  <p class="value">{{ this.physicianInfo.phone }}</p>
                </div>
              </el-col>

              <el-col :xl="4" :lg="4" :md="8" :sm="12" :xs="24">
                <div class="input-value">
                  <h4 class="name">Email</h4>
                  <p class="value">{{ this.physicianInfo.email || "--" }}</p>
                </div>
              </el-col>
              <el-col :xl="4" :lg="4" :md="8" :sm="12" :xs="24">
                <div class="input-value">
                  <h4 class="name">Fax</h4>
                  <p class="value">{{ this.physicianInfo.fax || "--" }}</p>
                </div>
              </el-col>
              <el-col :xl="4" :lg="4" :md="8" :sm="12" :xs="24">
                <div class="input-value">
                  <h4 class="name">Address Line 1</h4>

                  <p
                    class="value"
                    v-if="
                      this.physicianInfo.address &&
                      this.physicianInfo.address.address_line_1
                    "
                  >
                    {{ this.physicianInfo.address.address_line_1 }}
                  </p>
                  <p class="value" v-else>--</p>
                </div>
              </el-col>

              <el-col :xl="4" :lg="4" :md="8" :sm="12" :xs="24">
                <div class="input-value">
                  <h4 class="name">Address Line 2</h4>

                  <p
                    class="value"
                    v-if="
                      this.physicianInfo.address &&
                      this.physicianInfo.address.address_line_2
                    "
                  >
                    {{ this.physicianInfo.address.address_line_2 }}
                  </p>
                  <p v-else>--</p>
                </div>
              </el-col>
              <el-col :xl="4" :lg="4" :md="8" :sm="12" :xs="12">
                <div class="input-value">
                  <h4 class="name">ZIP</h4>

                  <p
                    class="value"
                    v-if="
                      this.physicianInfo.address &&
                      this.physicianInfo.address.zip
                    "
                  >
                    {{ this.physicianInfo.address.zip }}
                  </p>
                </div>
              </el-col>
              <el-col :xl="4" :lg="4" :md="8" :sm="12" :xs="12">
                <div class="input-value">
                  <h4 class="name">State</h4>

                  <p
                    class="value"
                    v-if="
                      this.physicianInfo.address &&
                      this.physicianInfo.address.state
                    "
                  >
                    {{ this.physicianInfo.address.state }}
                  </p>
                </div>
              </el-col>
              <el-col :xl="4" :lg="4" :md="8" :sm="12" :xs="12">
                <div class="input-value">
                  <h4 class="name">City</h4>

                  <p
                    class="value"
                    v-if="
                      this.physicianInfo.address &&
                      this.physicianInfo.address.city
                    "
                  >
                    {{ this.physicianInfo.address.city }}
                  </p>
                  <p v-else>-</p>
                </div>
              </el-col>

              <el-col :xl="8" :lg="8" :md="8" :sm="12" :xs="24">
                <div class="input-value">
                  <h4 class="name">Branches</h4>

                  <p
                    class="value"
                    v-if="
                      this.physicianInfo.hospital_branches &&
                      this.physicianInfo.hospital_branches.length
                    "
                  >
                    {{
                      this.physicianInfo.hospital_branches
                        .map(function (e) {
                          return e.display_name;
                        })
                        .join(", ")
                    }}
                  </p>
                  <p class="value" v-else>--</p>
                </div>
              </el-col>

              <el-col :xl="12" :lg="12" :md="8" :sm="12" :xs="24">
                <div class="input-value">
                  <h4 class="name">Specializations</h4>

                  <p
                    class="value"
                    v-if="
                      this.physicianInfo.specializations &&
                      this.physicianInfo.specializations.length
                    "
                  >
                    {{ this.physicianInfo.specializations.join(", ") }}
                  </p>
                  <p class="value" v-else>--</p>
                </div>
              </el-col>
              <el-col :xl="12" :lg="12" :md="8" :sm="12" :xs="24">
                <div class="input-value">
                  <h4 class="name">Ordering Facilities</h4>

                  <p
                    class="value"
                    v-if="
                      physicianInfo.hospitals && physicianInfo.hospitals.length
                    "
                  >
                    {{
                      physicianInfo.hospitals
                        .map((hospital) => hospital.name)
                        .join(", ")
                    }}
                  </p>
                  <p class="value" v-else>--</p>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import caseConstants from "@/config/constants/caseConstants";
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";
import {
  successNotification,
  errorNotification,
} from "@/helpers/notifications";
import { ElMessageBox } from "element-plus";

export default {
  mixins: [UserPermissionsHelper],

  computed: {
    ...mapGetters("cases", ["getCaseInformation","getPhysicianEnrollStatus","getPhysicianEnrolledData"]),
    ...mapGetters("auth", ["getAuthenticatedUser"]),
    ...mapGetters("physicians", [
      "getSinglePhysician",
      "getPecosData",
      "getPhysicianAddStatus",
      "getPhysicianValidationErrors",
    ]),
    getCaseTypes() {
      return (caseTypes) => {
        return (caseTypes || []).map((e) => this.caseTypeMap[e]);
      };
    },
    hadClinicalChemistry() {
      if (
        this.getCaseInformation &&
        this.getCaseInformation.case_types &&
        this.getCaseInformation.case_types.indexOf("CLINICAL_CHEMISTRY") > -1
      ) {
        return true;
      }
      return false;
    },
  },
  data() {
    return {
      caseTypeMap: caseConstants.CASE_TYPE_MAP,
      sampleTypes: [],
      physicianInfo: {},
      physician_id: "",
      physicianEditFormData: {
        npi_code: "",
        name: "",
        first_name: "",
        middle_name: "",
        last_name: "",
        phone: "",
        fax: "",
        email: "",
        hospital: "",
        hospital_branches: [],
        specializations: [],
        address: {
          address_line_1: "",
          address_line_2: "",
          city: "",
          state: "",
          zip: "",
        },
        settings: {
          auto_fax: false,
          email_notifications: false,
        },
      },
      loading: false,
      physicianDetailsPopUp: false,
    };
  },
  async created() {
    if (
      this.getCaseInformation &&
      this.getCaseInformation.ordering_physician &&
      this.getCaseInformation.ordering_physician._id
    ) {
      await this.fetchPhysicianDetails(
        this.getCaseInformation.ordering_physician._id
      );
      this.physician_id = this.getCaseInformation.ordering_physician._id;
    }
  },
  async mounted() {
    this.getSampleTypes();
  },
  methods: {
    async checkPhysicianEnroll(){
      let params = {
        size:10,
        offset:0,
        keyword:this.physicianInfo.npi_code || ""
      }
      await this.$store.dispatch("cases/physicianEnrolledData",params)
      if(this.getPhysicianEnrolledData && this.getPhysicianEnrolledData[0] &&
        this.getPhysicianEnrolledData[0][3]
      ){
        this.checkPhysicianEnrollStatus(this.getPhysicianEnrolledData[0][3])
      } else {
          errorNotification("Physician not enrolled")
        }
    },
    async checkPhysicianEnrollStatus(enroll){
      try {        
        this.loading = true;
        let physicianId = this.getCaseInformation && this.getCaseInformation.ordering_physician && this.getCaseInformation.ordering_physician._id;
        let params = {
          physician_id:physicianId,
        }
        if(enroll == 'Y'){
          params.is_enrolled = true
        } else {
          params.is_enrolled = false
        }
        await this.$store.dispatch("cases/checkPhysicianEnrollById",params)
        if(this.getPhysicianEnrollStatus){
          successNotification("Physician enrolled successfully")
          await this.fetchPhysicianDetails(this.physician_id);
        } else {
          errorNotification("Physician not enrolled")
        }
        this.loading = false;
      } catch (err){
        this.loading = false;
        console.log(err)
      } finally{
        this.loading = false;
      }
    },
    async fetchPhysicianDetails(physician_id) {
      await this.$store.dispatch("physicians/fetchSinglePhysician", {
        physician_id: physician_id,
        include_hospital_accounts: true,
        include_hospital_details: true,
      });
      this.physicianInfo = JSON.parse(JSON.stringify(this.getSinglePhysician));
    },
    preparePhysicianData() {
      if (this.physician_id) {
        this.physicianEditFormData.id = this.physician_id;
      }
      this.physicianEditFormData.hospitals = this.physicianInfo.hospitals
        ? this.physicianInfo.hospitals.map((e) => e._id)
        : [];
      this.physicianEditFormData.npi_code = this.physicianInfo.npi_code || "";
      this.physicianEditFormData.name = this.physicianInfo.name || "";
      this.physicianEditFormData.first_name = this.physicianInfo.name || "";
      this.physicianEditFormData.middle_name = this.physicianInfo.name || "";
      this.physicianEditFormData.last_name = this.physicianInfo.name || "";

      this.physicianEditFormData.phone = this.physicianInfo.phone || "";
      this.physicianEditFormData.fax = this.physicianInfo.fax || "";
      this.physicianEditFormData.email = this.physicianInfo.email || "";

      this.physicianEditFormData.hospital_branches = this.physicianInfo
        .hospital_branches
        ? this.physicianInfo.hospital_branches.map((e) => e._id)
        : [];
      this.physicianEditFormData.specializations =
        this.physicianInfo.specializations || [];
      this.physicianEditFormData.settings = {
        ...this.physicianEditFormData.settings,
        ...this.physicianInfo.settings,
      };
      if (this.physicianInfo.address) {
        this.physicianEditFormData.address.address_line_1 =
          this.physicianInfo.address.address_line_1 || "";
        this.physicianEditFormData.address.address_line_2 =
          this.physicianInfo.address.address_line_2 || "";
        this.physicianEditFormData.address.city =
          this.physicianInfo.address.city || "";
        this.physicianEditFormData.address.state =
          this.physicianInfo.address.state || "";
        this.physicianEditFormData.address.zip =
          this.physicianInfo.address.zip || "";
      } else {
        this.physicianEditFormData.address.address_line_1 = "";
        this.physicianEditFormData.address.address_line_2 = "";
        this.physicianEditFormData.address.city = "";
        this.physicianEditFormData.address.state = "";
        this.physicianEditFormData.address.zip = "";
      }

      return this.physicianEditFormData;
    },
    async reCheckPecosStatus() {
      this.loading = true;
      const payload = this.preparePhysicianData();
      if (!this.physicianEditFormData.first_name) delete payload.first_name;
      if (!this.physicianEditFormData.middle_name) delete payload.middle_name;
      if (!this.physicianEditFormData.last_name) delete payload.last_name;
      await this.$store.dispatch(
        "physicians/checkPecosStatus",
        this.physicianEditFormData.npi_code
      );
      if (this.getPecosData && this.getPecosData.length > 0) {
        this.physicianEditFormData.pecos_status = true;
        this.physicianEditFormData.pecos_number =
          this.getPecosData[0].PECOS_ASCT_CNTL_ID; // Accessing the first element of the array
      } else {
        this.physicianEditFormData.pecos_status = false;
        ElMessageBox.alert("Not enrolled in PECOS", "PECOS Status", {
          confirmButtonText: "OK",
          // type: "error",
          center: true,
          callback: () => {
            // Optional callback logic after the user closes the ElMessageBox
          },
        });
      }
      let previousPecosStatus = this.physicianInfo.pecos_status;
      if (previousPecosStatus != this.physicianEditFormData.pecos_status) {
        await this.$store.dispatch("physicians/editPhysician", payload);
        if (this.getPhysicianAddStatus) {
          successNotification(this.getPhysicianAddStatus.message);
          await this.fetchPhysicianDetails(this.physician_id);
        } else if (
          this.getPhysicianValidationErrors &&
          this.getPhysicianValidationErrors.critical_error
        ) {
          errorNotification(this.getPhysicianValidationErrors.critical_error);
        }
      }
      this.loading = false;
    },
    openPhysicianDetails() {
      this.physicianDetailsPopUp = true;
    },
    getSampleTypes() {
      if (
        this.getCaseInformation &&
        this.getCaseInformation.sample_types &&
        this.getCaseInformation.sample_types.length
      ) {
        for (let i = 0; i < this.getCaseInformation.sample_types.length; i++) {
          this.sampleTypes.push(
            this.getCaseInformation.sample_types[i].sample_types
          );
        }
      }
    },
    goToEditForm() {
      this.$router.push({
        name: "Case-Information-Update",
        params: { case_id: this.$route.params.case_id },
        query: this.$route.query,
      });
    },
  },
  watch: {
    getCaseInformation: {
      handler(newCaseInfo) {
        if( newCaseInfo &&
            newCaseInfo.ordering_physician &&
            newCaseInfo.ordering_physician._id
          ) {
          this.fetchPhysicianDetails(newCaseInfo.ordering_physician._id);
          this.physician_id = newCaseInfo.ordering_physician._id;
        }
      },
      immediate: true, 
      deep: true       
    }
  },
};
</script>

<style lang="scss" scoped>
.icd-codes {
  .indicatives {
    ul {
      display: flex;
      li {
        margin: 0 6px;
        p {
          .value {
            padding: 3px 12px !important;
          }
        }
      }
    }
  }
}
.cpt-codes {
  .indicatives {
    ul {
      display: flex;
      row-gap: 10px;
      li {
        margin: 0 5px;
        width: 45px;
        text-align: center;
        p {
          .value {
            padding: 3px 12px !important;
          }
        }
      }
    }
  }
}
</style>
